import React from 'react';
import ReactTooltip from 'react-tooltip';

const VisHoe = (props) => {

	const { currentStep } = props;

	const invissible  = {
		opacity: 0,
		transition: 'opacity 1s ease',
		pointerEvents: 'none'
	};
	const vissible  = {
		opacity: 1,
		transition: 'opacity 1s ease',
		pointerEvent: 'all'
	};

	const styleModel = (currentStep < 8) ? invissible : vissible;
	const styleOutput= (currentStep < 9) ? invissible : vissible;

	return (
		<div className="af-svg-wrapper">
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 480 360">
				<title>Hoe ramen we de koopkracht?</title>
				<g id="input">
					<rect x="1" y="1" width="108" height="66" rx="3" ry="3" fill="#fff"/>
					<path d="M23.33,5.92a2.17,2.17,0,1,1-2.17,2.16,2.17,2.17,0,0,1,2.17-2.16m0-2.17a4.33,4.33,0,1,0,4.33,4.33,4.33,4.33,0,0,0-4.33-4.33Zm0,15.16a2.17,2.17,0,1,1-2.17,2.17,2.18,2.18,0,0,1,2.17-2.17m0-2.16a4.33,4.33,0,1,0,4.33,4.33,4.33,4.33,0,0,0-4.33-4.33Zm-13,15.16a2.17,2.17,0,1,1-2.16,2.17,2.17,2.17,0,0,1,2.16-2.17m0-2.17a4.34,4.34,0,1,0,4.33,4.34,4.33,4.33,0,0,0-4.33-4.34Zm26-23.82a2.17,2.17,0,1,1-2.17,2.16,2.16,2.16,0,0,1,2.17-2.16m0-2.17a4.33,4.33,0,1,0,4.33,4.33,4.33,4.33,0,0,0-4.33-4.33ZM24.41,37.33v-6.5a1.08,1.08,0,0,0-2.16,0v6.5a1.08,1.08,0,1,0,2.16,0Zm13,0v-6.5a1.09,1.09,0,0,0-2.17,0v6.5a1.09,1.09,0,0,0,2.17,0Zm0-13v-6.5a1.09,1.09,0,0,0-2.17,0v6.5a1.09,1.09,0,0,0,2.17,0Zm-26,0v-6.5a1.09,1.09,0,0,0-2.17,0v6.5a1.09,1.09,0,0,0,2.17,0Zm0-13V4.83a1.09,1.09,0,0,0-2.17,0v6.5a1.09,1.09,0,0,0,2.17,0Z" fill="#a90060"/>
					<path d="M85.67,5.92A2.17,2.17,0,1,1,83.5,8.08a2.17,2.17,0,0,1,2.17-2.16m0-2.17A4.33,4.33,0,1,0,90,8.08a4.33,4.33,0,0,0-4.33-4.33Zm0,15.16a2.17,2.17,0,1,1-2.17,2.17,2.18,2.18,0,0,1,2.17-2.17m0-2.16A4.33,4.33,0,1,0,90,21.08a4.33,4.33,0,0,0-4.33-4.33Zm-13,15.16a2.17,2.17,0,1,1-2.16,2.17,2.17,2.17,0,0,1,2.16-2.17m0-2.17A4.34,4.34,0,1,0,77,34.08a4.33,4.33,0,0,0-4.33-4.34Zm26-23.82A2.17,2.17,0,1,1,96.5,8.08a2.16,2.16,0,0,1,2.17-2.16m0-2.17A4.33,4.33,0,1,0,103,8.08a4.33,4.33,0,0,0-4.33-4.33ZM86.75,37.33v-6.5a1.08,1.08,0,0,0-2.16,0v6.5a1.08,1.08,0,0,0,2.16,0Zm13,0v-6.5a1.09,1.09,0,0,0-2.17,0v6.5a1.09,1.09,0,0,0,2.17,0Zm0-13v-6.5a1.09,1.09,0,0,0-2.17,0v6.5a1.09,1.09,0,0,0,2.17,0Zm-26,0v-6.5a1.09,1.09,0,0,0-2.17,0v6.5a1.09,1.09,0,0,0,2.17,0Zm0-13V4.83a1.09,1.09,0,0,0-2.17,0v6.5a1.09,1.09,0,0,0,2.17,0Z" fill="#a90060"/>
					<path d="M60.88,5.92a2.17,2.17,0,1,1-2.17,2.16,2.16,2.16,0,0,1,2.17-2.16m0-2.17a4.33,4.33,0,1,0,4.33,4.33,4.33,4.33,0,0,0-4.33-4.33Zm0,15.16a2.17,2.17,0,1,1-2.17,2.17,2.17,2.17,0,0,1,2.17-2.17m0-2.16a4.33,4.33,0,1,0,4.33,4.33,4.33,4.33,0,0,0-4.33-4.33Zm-13,15.16a2.17,2.17,0,1,1-2.17,2.17,2.17,2.17,0,0,1,2.17-2.17m0-2.17a4.34,4.34,0,1,0,4.33,4.34,4.33,4.33,0,0,0-4.33-4.34ZM62,37.33v-6.5a1.08,1.08,0,0,0-2.16,0v6.5a1.08,1.08,0,1,0,2.16,0Zm-13-13v-6.5a1.08,1.08,0,0,0-2.16,0v6.5a1.08,1.08,0,1,0,2.16,0ZM23.33,44.19a2.17,2.17,0,1,1-2.17,2.16,2.17,2.17,0,0,1,2.17-2.16m0-2.17a4.34,4.34,0,1,0,4.33,4.33A4.33,4.33,0,0,0,23.33,42Zm-13,15.16a2.17,2.17,0,1,1-2.16,2.17,2.17,2.17,0,0,1,2.16-2.17m0-2.16a4.33,4.33,0,1,0,4.33,4.33A4.33,4.33,0,0,0,10.33,55ZM24.41,62.6V56.1a1.08,1.08,0,0,0-2.16,0v6.5a1.08,1.08,0,0,0,2.16,0Zm13,0V56.1a1.09,1.09,0,0,0-2.17,0v6.5a1.09,1.09,0,0,0,2.17,0Zm0-13V43.1a1.09,1.09,0,0,0-2.17,0v6.5a1.09,1.09,0,1,0,2.17,0Zm-26,0V43.1a1.09,1.09,0,0,0-2.17,0v6.5a1.09,1.09,0,1,0,2.17,0Zm74.25-5.41a2.17,2.17,0,1,1-2.17,2.16,2.17,2.17,0,0,1,2.17-2.16m0-2.17A4.34,4.34,0,1,0,90,46.35,4.33,4.33,0,0,0,85.67,42Zm-13,15.16a2.17,2.17,0,1,1-2.16,2.17,2.17,2.17,0,0,1,2.16-2.17m0-2.16A4.33,4.33,0,1,0,77,59.35,4.33,4.33,0,0,0,72.67,55ZM86.75,62.6V56.1a1.08,1.08,0,0,0-2.16,0v6.5a1.08,1.08,0,0,0,2.16,0Zm13,0V56.1a1.09,1.09,0,0,0-2.17,0v6.5a1.09,1.09,0,0,0,2.17,0Zm0-13V43.1a1.09,1.09,0,0,0-2.17,0v6.5a1.09,1.09,0,1,0,2.17,0Zm-26,0V43.1a1.09,1.09,0,0,0-2.17,0v6.5a1.09,1.09,0,1,0,2.17,0ZM60.88,44.19a2.17,2.17,0,1,1-2.17,2.16,2.16,2.16,0,0,1,2.17-2.16m0-2.17a4.34,4.34,0,1,0,4.33,4.33A4.33,4.33,0,0,0,60.88,42Zm-13,15.16a2.17,2.17,0,1,1-2.17,2.17,2.17,2.17,0,0,1,2.17-2.17m0-2.16a4.33,4.33,0,1,0,4.33,4.33A4.33,4.33,0,0,0,47.88,55ZM62,62.6V56.1a1.08,1.08,0,0,0-2.16,0v6.5a1.08,1.08,0,1,0,2.16,0Zm-13-13V43.1a1.08,1.08,0,0,0-2.16,0v6.5a1.08,1.08,0,1,0,2.16,0Zm0-38.27V4.83a1.08,1.08,0,0,0-2.16,0v6.5a1.08,1.08,0,0,0,2.16,0Z" fill="#a90060"/>

					<rect x="2" y="76" width="106" height="76" rx="3" fill="none" stroke="#fff" strokeWidth="1.2" />
					<text transform="translate(8 92)" fontSize="13" fill="#fff" fontWeight="700" fontFamily="Sans, RijksoverheidSansText-Regular, RijksoverheidSansText, Arial, sans-serif">
						<tspan x="0" y="0">1. Steekproef</tspan>
						<tspan x="0" y="16">2. Raming lonen</tspan>
						<tspan x="14" y="32">en inflatie</tspan>
						<tspan x="0" y="48">3. Beleid</tspan>
					</text>

					<line x1="114" y1="81" x2="128.17" y2="81" fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth="9"/>
					<polygon points="126.34 67.33 126.34 94.67 140 81 126.34 67.33" fill="#fff"/>
				</g>

				<g id="model-buiten">
					<rect x="144" y="63" width="190" height="261" rx="3.01" ry="3.01" fill="#fff"/>
					<text transform="translate(158.66 96.8)" fontSize="30" fill="#a90060" fontFamily="Sans, RijksoverheidSansText-Regular, RijksoverheidSansText, Arial, sans-serif"fontWeight="700">Model</text>
          <g className="cogs" transform="translate(275 90)">
            <rect x="-20" y="-20" width="70" height="60" opacity="0"></rect>
            <g transform="translate(25 0)">
            <path className="cog1" d="M14.76,2.15,11.44,1.06a11.37,11.37,0,0,0-.29-3.84l3.11-1.57a1.94,1.94,0,0,0,.85-2.58l-.58-1.14A1.91,1.91,0,0,0,12-8.91L8.85-7.34A11.29,11.29,0,0,0,5.92-9.85L7-13.16a1.92,1.92,0,0,0-1.23-2.42L4.57-16a1.92,1.92,0,0,0-2.42,1.22L1.06-11.44a11.41,11.41,0,0,0-1.94,0,11.43,11.43,0,0,0-1.9.32l-1.57-3.11a1.94,1.94,0,0,0-2.58-.85l-1.14.58A1.91,1.91,0,0,0-8.91-12l1.57,3.12A11.62,11.62,0,0,0-9.85-5.92L-13.16-7a1.92,1.92,0,0,0-2.42,1.23L-16-4.57a1.92,1.92,0,0,0,1.22,2.42l3.32,1.09a11.37,11.37,0,0,0,.29,3.84l-3.11,1.57a1.94,1.94,0,0,0-.85,2.58l.58,1.14A1.91,1.91,0,0,0-12,8.91l3.11-1.57A11.29,11.29,0,0,0-5.92,9.85L-7,13.16a1.92,1.92,0,0,0,1.23,2.42l1.21.4a1.92,1.92,0,0,0,2.42-1.22l1.09-3.32a11.41,11.41,0,0,0,1.94,0,11.43,11.43,0,0,0,1.9-.32l1.57,3.11a1.94,1.94,0,0,0,2.58.85l1.14-.58A1.91,1.91,0,0,0,8.91,12L7.34,8.84A11.62,11.62,0,0,0,9.85,5.92L13.16,7a1.92,1.92,0,0,0,2.42-1.23L16,4.57A1.92,1.92,0,0,0,14.76,2.15ZM1.16,5.63.78,5.7A5.73,5.73,0,0,1-3.78,4.32,5.66,5.66,0,0,1-5,2.9,5.84,5.84,0,0,1-5.73.38a5.78,5.78,0,0,1,1.4-4.16A5.93,5.93,0,0,1-2.9-5a6.12,6.12,0,0,1,1.74-.66l.38-.07A5.73,5.73,0,0,1,3.78-4.32,5.66,5.66,0,0,1,5-2.9,5.84,5.84,0,0,1,5.73-.38a5.78,5.78,0,0,1-1.4,4.16A5.93,5.93,0,0,1,2.9,5,6.12,6.12,0,0,1,1.16,5.63Z" fill="#a90060"/>
            </g>
            <g transform="translate(-2 12)">
            <path className="cog2" d="M12.4-.35,8.88-1a8.82,8.82,0,0,0-.46-2,8.93,8.93,0,0,0-.94-1.85L9.8-7.61a1.93,1.93,0,0,0-.22-2.7l-1-.82a1.93,1.93,0,0,0-2.7.22L3.59-8.18a8.75,8.75,0,0,0-2-.62A8.42,8.42,0,0,0-.48-8.92l-1.21-3.37a1.93,1.93,0,0,0-2.45-1.16l-1.2.43A1.94,1.94,0,0,0-6.5-10.56L-5.3-7.2A8.84,8.84,0,0,0-8-4l-3.52-.64a1.91,1.91,0,0,0-2.22,1.54l-.23,1.26A1.92,1.92,0,0,0-12.4.35L-8.88,1a8.82,8.82,0,0,0,.46,2,8.93,8.93,0,0,0,.94,1.85L-9.8,7.61a1.93,1.93,0,0,0,.22,2.7l1,.82a1.93,1.93,0,0,0,2.7-.22l2.31-2.73a8.75,8.75,0,0,0,2,.62,8.42,8.42,0,0,0,2.07.12l1.21,3.37a1.93,1.93,0,0,0,2.45,1.16L5.34,13A1.94,1.94,0,0,0,6.5,10.56L5.3,7.2A8.84,8.84,0,0,0,8,4l3.52.64a1.91,1.91,0,0,0,2.22-1.54l.23-1.26A1.92,1.92,0,0,0,12.4-.35ZM.19,4.46H-.18A4.48,4.48,0,0,1-4,2.07a2.39,2.39,0,0,1-.15-.37,4.47,4.47,0,0,1-.16-3,4.51,4.51,0,0,1,.73-1.37A4.34,4.34,0,0,1-2.07-4a4.46,4.46,0,0,1,1.88-.5H.18A4.48,4.48,0,0,1,4-2.07a2.39,2.39,0,0,1,.15.37,4.47,4.47,0,0,1,.16,3,4.51,4.51,0,0,1-.73,1.37A4.34,4.34,0,0,1,2.07,4,4.46,4.46,0,0,1,.19,4.46Z" fill="#a90060"/>
            </g>
            <g transform="translate(15 28)">
            <path className="cog3" d="M8.38,5.31l-2.05-2a6.82,6.82,0,0,0,.6-1.56A7.17,7.17,0,0,0,7.14.11L9.9-.67A1.54,1.54,0,0,0,11-2.56l-.28-1A1.54,1.54,0,0,0,8.79-4.6L6-3.83a7.29,7.29,0,0,0-1-1.3,6.84,6.84,0,0,0-1.32-1l.7-2.78a1.54,1.54,0,0,0-1.11-1.86l-1-.25A1.54,1.54,0,0,0,.41-9.91l-.7,2.76a7.18,7.18,0,0,0-3.19.91l-2.05-2a1.53,1.53,0,0,0-2.17,0l-.71.73a1.54,1.54,0,0,0,0,2.17l2.05,2a6.82,6.82,0,0,0-.6,1.56A7.17,7.17,0,0,0-7.14-.11L-9.9.67A1.54,1.54,0,0,0-11,2.56l.28,1A1.54,1.54,0,0,0-8.79,4.6L-6,3.83a7.29,7.29,0,0,0,1,1.3,6.84,6.84,0,0,0,1.32,1l-.7,2.78a1.54,1.54,0,0,0,1.11,1.86l1,.25A1.54,1.54,0,0,0-.41,9.91l.7-2.76a7.18,7.18,0,0,0,3.19-.91l2.05,2a1.53,1.53,0,0,0,2.17,0l.71-.73A1.54,1.54,0,0,0,8.38,5.31ZM-2.22,2.8l-.23-.19a3.6,3.6,0,0,1-1-3.43c0-.1.07-.2.1-.3A3.5,3.5,0,0,1-1.88-3,3.32,3.32,0,0,1-.73-3.49a3.53,3.53,0,0,1,1.55,0,3.45,3.45,0,0,1,1.4.68l.23.19a3.6,3.6,0,0,1,1,3.43c0,.1-.07.2-.1.3A3.5,3.5,0,0,1,1.88,3a3.32,3.32,0,0,1-1.15.45,3.53,3.53,0,0,1-1.55,0A3.45,3.45,0,0,1-2.22,2.8Z" fill="#a90060"/>
            </g>
          </g>
				</g>

				<g id="model-binnen" style={styleModel} fontSize="13" fill="#fff" fontFamily="Sans, RijksoverheidSansText-Regular, RijksoverheidSansText, sans-serif" fontWeight="700" textAnchor="middle" >

					<g data-html={true}
						data-tip="Bruto inkomen =
							Loon, winst, uitkering, pensioen<br />
							+ Inkomen uit aanmerkelijk belang<br />
							+ Inkomen uit vermogen (rente en dividend)<br />
							+ Inkomsten minus uitgaven eigen woning<br />
							+ Ontvangen minus betaalde alimentatie<br />"
					>
						<rect x="159" y="155" width="160" height="24" rx="6.05" ry="6.05" fill="#e5b2cf" />
						<text transform="translate(239 171.5)" fill="#333" >Bruto inkomen</text>
					</g>

					<g data-html={true}
						data-tip="
							Netto inkomen = Bruto inkomen<br />
							+ Heffingskortingen<br />
							– Werknemerspremie pensioen/vut<br />
							– Inkomensafhankelijke eigen bijdrage Zvw<br />
							– Premies volksverzekeringen, belastingen box 1, 2, 3<br />
							– Fiscaal effect aftrekposten"
					>
						<rect x="159" y="215" width="160" height="24" rx="6.05" ry="6.05" fill="#e5b2cf"/>
						<text transform="translate(239 231.5)" fill="#333" >Netto inkomen</text>
					</g>

					<g data-html={true}
						data-tip="
							Besteedbaar inkomen = Netto inkomen<br />
							+ Kinderbijslag<br />
							+ Toeslagen (huur, zorg, kindgebonden, kinderopvang)<br />
							+ Tegemoetkomingen (specifieke zorgkosten)<br />
							+ Studiefinanciering<br />
							– Nominale ziektekostenpremies en betalingen eigen risico<br />
							– Kosten kinderopvang"
					>
						<rect x="159" y="275" width="160" height="24" rx="6.05" ry="6.05" fill="#e5b2cf"/>
						<text transform="translate(239 291.5)" fill="#333" >Besteedbaar inkomen</text>
					</g>

					<g>
						<line x1="239.49" y1="183.63" x2="239.49" y2="197.8" fill="none" stroke="#e5b2cf" strokeMiterlimit="10" strokeWidth="9"/>
						<polygon points="253.15 195.96 225.82 195.96 239.49 209.63 253.15 195.96" fill="#e5b2cf"/>
					</g>

					<g transform="translate(0,60)">
						<line x1="239.49" y1="183.63" x2="239.49" y2="197.8" fill="none" stroke="#e5b2cf" strokeMiterlimit="10" strokeWidth="9"/>
						<polygon points="253.15 195.96 225.82 195.96 239.49 209.63 253.15 195.96" fill="#e5b2cf"/>
					</g>

				</g>

				<g id="output" style={styleOutput}>
					<rect x="369" y="214" width="108" height="65" rx="3" ry="3" fill="#fff"/>
					<g id="procenten" fontSize="10" fill="#a90060" fontFamily="Sans, SourceSansPro-Bold, Source Sans Pro" fontWeight="700">
						<text transform="translate(373.17 233.54)">%</text>
						<text transform="translate(373.17 266.03)">%</text>
						<text transform="translate(373.17 244.37)">%</text>
						<text transform="translate(373.17 255.2)">%</text>
						<text transform="translate(373.17 276.85)">%</text>
						<text transform="translate(373.17 222.71)">%</text>
						<text transform="translate(386.17 233.54)">%</text>
						<text transform="translate(386.17 266.03)">%</text>
						<text transform="translate(386.17 244.37)">%</text>
						<text transform="translate(386.17 255.2)">%</text>
						<text transform="translate(386.17 276.85)">%</text>
						<text transform="translate(386.17 222.71)">%</text>
						<text transform="translate(399.17 233.54)">%</text>
						<text transform="translate(399.17 266.03)">%</text>
						<text transform="translate(399.17 244.37)">%</text>
						<text transform="translate(399.17 255.2)">%</text>
						<text transform="translate(399.17 276.85)">%</text>
						<text transform="translate(399.17 222.71)">%</text>
						<text transform="translate(412.17 233.54)">%</text>
						<text transform="translate(412.17 266.03)">%</text>
						<text transform="translate(412.17 244.37)">%</text>
						<text transform="translate(412.17 255.2)">%</text>
						<text transform="translate(412.17 276.85)">%</text>
						<text transform="translate(412.17 222.71)">%</text>
						<text transform="translate(425.17 233.54)">%</text>
						<text transform="translate(425.17 266.03)">%</text>
						<text transform="translate(425.17 244.37)">%</text>
						<text transform="translate(425.17 255.2)">%</text>
						<text transform="translate(425.17 276.85)">%</text>
						<text transform="translate(425.17 222.71)">%</text>
						<text transform="translate(438.17 233.54)">%</text>
						<text transform="translate(438.17 244.37)">%</text>
						<text transform="translate(438.17 255.2)">%</text>
						<text transform="translate(438.17 266.03)">%</text>
						<text transform="translate(438.17 276.85)">%</text>
						<text transform="translate(438.17 222.71)">%</text>
						<text transform="translate(451.17 233.54)">%</text>
						<text transform="translate(451.17 266.03)">%</text>
						<text transform="translate(451.17 244.37)">%</text>
						<text transform="translate(451.17 255.2)">%</text>
						<text transform="translate(451.17 276.85)">%</text>
						<text transform="translate(451.17 222.71)">%</text>
						<text transform="translate(464.17 233.54)">%</text>
						<text transform="translate(464.17 266.03)">%</text>
						<text transform="translate(464.17 244.37)">%</text>
						<text transform="translate(464.17 255.2)">%</text>
						<text transform="translate(464.17 276.85)">%</text>
						<text transform="translate(464.17 222.71)">%</text>
					</g>

					<path d="M474,289a2,2,0,0,1,2,2v64a2,2,0,0,1-2,2H372a2,2,0,0,1-2-2V291a2,2,0,0,1,2-2H474m0-1H372a3,3,0,0,0-3,3v64a3,3,0,0,0,3,3H474a3,3,0,0,0,3-3V291a3,3,0,0,0-3-3Z" fill="#fff"/>
					<g>
						<line x1="338" y1="290.5" x2="352.17" y2="290.5" fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth="9"/>
						<polygon points="350.34 276.83 350.34 304.17 364 290.5 350.34 276.83" fill="#fff"/>
					</g>
					{/*
					<rect x="400.5" y="237" width="45" height="21" rx="3" ry="3" fill="#a90060"/>
					<text transform="translate(409.68 250.76)" fontSize="13" fill="#fff" fontFamily="RijksoverheidSansText-Regular, RijksoverheidSansText, Arial, sans-serif" fontWeight="700">100K</text>
					*/}
					<text transform="translate(375 303)" fontSize="13" fill="#fff" fontWeight="700" fontFamily="Sans, RijksoverheidSansText-Regular, RijksoverheidSansText, sans-serif">
						<tspan x="0" y="0">Koopkracht-</tspan>
						<tspan x="0" y="16">ontwkkeling</tspan>
						<tspan x="0" y="32">huishoudens</tspan>
					</text>
				</g>

			</svg>
			<ReactTooltip className='af-tooltip-hoe' />
		</div>
	)
}


export default VisHoe;



// WEBPACK FOOTER //
// ./src/components/Visualization/VisHoe.js